var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 119,
    viewBox: "0 0 158 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.625 118.875V85.125H107.125L79 51.375L50.875 85.125H73.375V118.875H45.25V118.594C44.305 118.65 43.405 118.875 42.4375 118.875C31.2487 118.875 20.5181 114.43 12.6064 106.519C4.69474 98.6069 0.25 87.8763 0.25 76.6875C0.25 55.0425 16.6187 37.4025 37.6225 34.9838C39.464 25.357 44.6025 16.6729 52.1542 10.425C59.7059 4.17708 69.1987 0.75594 79 0.75C88.8026 0.755486 98.297 4.17622 105.851 10.424C113.404 16.6718 118.545 25.3561 120.389 34.9838C141.393 37.4025 157.739 55.0425 157.739 76.6875C157.739 87.8763 153.294 98.6069 145.382 106.519C137.471 114.43 126.74 118.875 115.551 118.875C114.606 118.875 113.695 118.65 112.739 118.594V118.875H84.625Z",
    fill: "#CCCCCC",
    fillOpacity: 0.34
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/uploadFileIcon.db719609f6d83fabf3bd8b932287ad52.svg";
export { ForwardRef as ReactComponent };